import React, { useEffect, useState } from "react";
import "../Assets/WebsiteCss/ConstructionPlanning.css";
import constructionImg from "../Assets/images/construction.jpg";
import siteWork from "../Assets/images/site_work.jpg";
import {
  FaHardHat,
  FaTools,
  FaBuilding,
  FaCheckCircle,
  FaHome,
} from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../BaseURL";
import ProjectsPreview from "../Components/ProjectsPreview";

const ConstructionPlanning = () => {
  const features = [
    {
      icon: <FaHardHat />,
      title: "Expert Site Supervision",
      description:
        "Experienced engineers and supervisors ensuring quality execution at every stage",
    },
    {
      icon: <FaTools />,
      title: "Quality Materials",
      description:
        "Use of certified materials and trusted brands for long-lasting structures",
    },
    {
      icon: <FaBuilding />,
      title: "On-Time Delivery",
      description:
        "Well-planned schedules and execution to deliver your project on time",
    },
  ];

  const [projects, setProjects] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const projectRes = await axios.get(`${BASE_URL}/api/projects`);
      const categoryRes = await axios.get(
        `${BASE_URL}/api/category/get-category`
      );

      const map = {};
      categoryRes.data.data.forEach((c) => {
        map[c._id] = c.categoryName;
      });

      const allProjects = projectRes.data.data;

      // Latest 3 projects
      setProjects(allProjects.slice(-3).reverse());
      setCategoryMap(map);
    };

    loadData();
  }, []);

  return (
    <div className="cp-page">
      {/* HERO SECTION */}
      <section className="cp-hero">
        <div className="cp-hero-overlay" />
        <div className="cp-hero-content">
          <div className="cp-hero-badge">
            <FaHome /> Our Services
          </div>
          <h1 className="cp-hero-title">
            Construction Planning
            <span className="cp-highlight">&amp; Execution</span>
          </h1>
          <p className="cp-hero-subtitle">
            From foundation to finishing, we manage and execute construction
            projects with precision, quality, and complete transparency. Your
            vision, built to perfection.
          </p>

          <div className="cp-hero-stats">
            <div className="cp-stat-item">
              <span className="cp-stat-number">300+</span>
              <span className="cp-stat-label">Projects Completed</span>
            </div>
            <div className="cp-stat-divider" />
            <div className="cp-stat-item">
              <span className="cp-stat-number">100%</span>
              <span className="cp-stat-label">Quality Assurance</span>
            </div>
            <div className="cp-stat-divider" />
            <div className="cp-stat-item">
              <span className="cp-stat-number">15+</span>
              <span className="cp-stat-label">Years Experience</span>
            </div>
          </div>
        </div>
      </section>

      {/* SHOWCASE SECTION */}
      <section className="cp-showcase-section">
        <div className="cp-showcase-grid">
          <div className="cp-showcase-item">
            <div className="cp-showcase-image-wrapper">
              <img
                src={constructionImg}
                alt="Construction Site Work"
                className="cp-showcase-image"
              />
              <div className="cp-image-badge">Construction</div>
            </div>

            <div className="cp-showcase-content">
              <h3>End-to-End Construction</h3>
              <p>
                We handle the complete construction lifecycle — from groundwork
                to final handover — ensuring structural strength and finishing
                excellence at every stage of your project.
              </p>

              <ul className="cp-showcase-features">
                <li>
                  <FaCheckCircle /> Foundation & RCC work
                </li>
                <li>
                  <FaCheckCircle /> Masonry & plastering
                </li>
                <li>
                  <FaCheckCircle /> Electrical & plumbing
                </li>
                <li>
                  <FaCheckCircle /> Finishing & handover
                </li>
              </ul>
            </div>
          </div>

          <div className="cp-showcase-item cp-reverse">
            <div className="cp-showcase-image-wrapper">
              <img
                src={siteWork}
                alt="Professional Site Management"
                className="cp-showcase-image"
              />
              <div className="cp-image-badge">Site Management</div>
            </div>

            <div className="cp-showcase-content">
              <h3>Professional Site Management</h3>
              <p>
                Our team coordinates labor, materials, and timelines to ensure
                smooth site operations and minimal delays. Experience
                hassle-free construction with our expert management.
              </p>

              <ul className="cp-showcase-features">
                <li>
                  <FaCheckCircle /> Daily supervision
                </li>
                <li>
                  <FaCheckCircle /> Material procurement
                </li>
                <li>
                  <FaCheckCircle /> Safety compliance
                </li>
                <li>
                  <FaCheckCircle /> Progress reporting
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="cp-features-section">
        <div className="cp-section-header">
          <h2 className="cp-section-title">
            Why Choose Our Construction Services
          </h2>
        </div>

        <div className="cp-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="cp-feature-card">
              <div className="cp-feature-icon">{feature.icon}</div>
              <h3 className="cp-feature-title">{feature.title}</h3>
              <p className="cp-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* RELATED PROJECTS */}
      <section className="cp-related-projects">
        <div className="cp-section-header">
          <h2 className="cp-section-title">Some of our recent projects</h2>
        </div>

        <div className="cp-projects-wrapper">
          <ProjectsPreview projects={projects} categoryMap={categoryMap} />
        </div>
      </section>
    </div>
  );
};

export default ConstructionPlanning;